<template>
    <v-container fluid fill-height class="main-container container-fixed d-block">
        <div class="content-block">
            <HeaderMenu title="Сценарии работы устройств" :has-notification="hasNewMessages" class="px-6"/>
<!--            <v-layout row class="locations-group-row" v-dragscroll.x>-->
<!--                <v-btn-->
<!--                    class="locations-group__btn mx-1"-->
<!--                    active-class="locations-group__btn-active"-->
<!--                    v-for="(location, index) in locations"-->
<!--                    :key="index"-->
<!--                    :input-value="activeGroup == index"-->
<!--                    depressed-->
<!--                    rounded-->
<!--                    :id="`location${index}`"-->
<!--                    @click="setActiveGroup(index)"-->
<!--                >-->
<!--                    {{ location }}-->
<!--                </v-btn>-->
<!--            </v-layout>-->
            <BottomSheet
                v-if="locations && locations.length > 5"
                ref="BottomSheet"
                :activeGroup="activeGroup"
                :locations="locations"
                :offset="1"
                @setRoom="setActiveGroup"
            ></BottomSheet>
            <v-layout row class="locations-group-row" v-dragscroll.x>
                <v-btn
                    v-if="locations && locations.length > 5"
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    :input-value="activeGroup > 0"
                    depressed
                    rounded
                    @click="openSheet"
                >
                    {{activeGroup > 0 ? locations[activeGroup] : "Выберите комнату"}}
                    <v-img
                        max-height="20px"
                        max-width="20px"
                        :src="require('@/assets/icons/arrow_down_icon.svg')"
                        class="d-inline-flex ml-2"
                    />
                </v-btn>
                <v-btn
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    v-for="(location, index) in locationsScroll"
                    :key="index"
                    :input-value="activeGroup == index"
                    depressed
                    rounded
                    :id="`location${index}`"
                    @click="setActiveGroup(index)"
                >
                    {{ location }}
                </v-btn>
            </v-layout>

            <v-layout class="scenarios-list scroll-layout px-6" column :key="activeGroup">
                <div v-for="(group, index) in filtredGroups" :key="'group' + index">
                    <ScenarioGroup :group="group" :showLocation="activeGroup === 0" :available="available"/>
                </div>
                <div v-for="(scenario, index) in filtredScenarios" :key="'scenario' + index">
                    <ScenarioSwitch :scenario="scenario" :showLocation="activeGroup === 0" :available="available"/>
                </div>
            </v-layout>
            <ModalOffline ref="modalErrorScenarioOffline"></ModalOffline>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка сценариев" noCancel></ModalWaiting>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import ScenarioSwitch from "@/components/ScenarioSwitch";
import ModalOffline from "@/components/modals/ModalOffline";
import ScenarioGroup from "@/components/ScenarioGroup";
import ModalWaiting from "@/components/modals/ModalWaiting";
import BottomSheet from "@/components/BottomSheet";
import {eventBus} from "@/main";
import { dragscroll } from 'vue-dragscroll';

export default {
    name: "ScenariosList",
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        HeaderMenu,
        ScenarioSwitch,
        ModalOffline,
        ScenarioGroup,
        ModalWaiting,
        BottomSheet,
    },
    data() {
        return {
            scenarios: [],
            groups: [],
            hasNewMessages: false,
            activeGroup: 0,
            categories: ["Все"],
            locations: [],
            available: [],
        };
    },
    created() {
        eventBus.$on("scenarioGroup", this.updateScenariosGroup);
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("scenarioGroup", this.updateScenariosGroup);
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    computed: {
        filtredGroups() {
            if (this.activeGroup > 0) {
                return this.groups.filter((el) => { return el.location === this.locations[this.activeGroup] });
            }
            return this.groups;
        },
        filtredScenarios() {
            if (this.activeGroup > 0) {
                return this.scenarios.filter((el) => { return el.location === this.locations[this.activeGroup] });
            }
            return this.scenarios;
        },
        locationsScroll() {
            if (this.locations && this.locations.length < 6) {
                return this.locations;
            }
            return this.categories;
        },
    },
    methods: {
        loadPage() {
            if (this.$route.query.master_key) {
                this.$router.push({name: "master", query: this.$route.query});
            } else if (this.$store.state.accessToken) {
                this.getScenarios();
            } else {
                this.$router.push({ name: "empty" });
            }
        },
        getScenarios() {
            this.$refs.modalWaiting.open();
            this.locations = [];
            this.scenarios = [];
            this.groups = [];
            this.hasNewMessages = false;
            this.$http.get('/scenarios/guest/scenarios/')
                .then((response) => {
                    if (!response.data.online) {
                        this.$refs.modalErrorScenarioOffline.open();
                    }
                    this.hasNewMessages =  response.data.have_unread_messages;
                    this.scenarios = response.data.scenarios;
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    response.data.locations.forEach((el) => {
                        if (el) {
                            this.locations.push(el);
                        }
                    });
                    this.groups = response.data.groups;
                    this.available = response.data.available_conditions_and_actions;
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.code == "access_key_expiration_date_has_expired") {
                        this.$router.push({ name: "final", params: { message: error.response.data.message }});
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if (this.$store.state.storeActiveGroup !== null) {
                            let i = this.locations.indexOf(this.$store.state.storeActiveGroup);
                            if (i !== -1) {
                                this.activeGroup = i;
                                // document.getElementById(`location${this.activeGroup}`).scrollIntoView({inline: "center"});
                            }
                        }
                    });
                    this.$refs.modalWaiting.close();
                });
        },
        updateScenariosGroup(data) {
            let groupChanged = this.groups.filter((el) => { return el.uid == data.group.uid })[0];
            let groupIndex = this.groups.indexOf(groupChanged);
            this.$set(this.groups, groupIndex, data.group);
        },
        setActiveGroup(index) {
            this.activeGroup = index;
            this.$store.commit("setActiveGroup", this.locations[this.activeGroup]);
        },
        openSheet() {
            this.$refs.BottomSheet.open();
        },
    },
}
</script>

<style lang="scss">
.main-container.container-fixed .scenarios-list.scroll-layout {
    margin-top: 16px;
    padding-bottom: 100px;
}
</style>